import { isSameId } from "../../helpers";
export default function (store, { id }) {
    if (id) {
        const state = store.getState();
        const originalLink = state.links.find(link => isSameId(link.id, id));
        const links = state.links.filter(link => !isSameId(link.id, id));
        store.setState({ links });
        return () => {
            store.in.exec("add-link", {
                id,
                link: originalLink,
                $meta: { skipHistory: true },
            });
        };
    }
}
//# sourceMappingURL=delete.js.map